import React, { useEffect, useState } from 'react';
import styles from '../styles/internships.module.scss';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import NeedGuidance from './NeedGuidance';
import WebinarEvents from './WebinarEvents';
import FeaturedBlogs from './FeaturedBlogs';
import Testimonial from './Testimonial';
import { FilterProps } from './Universities';
import _debounce from 'lodash/debounce';
import fetchUtil from '../utils/fetchUtil';
import KcNewLatestUpdates from './kcNewlatestupdates';
import CustomImage from './CustomImage';
import FaqComponent from './PST/FrequentlyAskedQuestions';
import Button from 'react-bootstrap/Button';
import { isFrappeOrJotFormClass } from '../utils/helpers';

const Internship: React.FC = (props: any) => {
  const initialValues = {
    country: 'USA',
    searchValue: '',
    pageNo: 1
  }
  const [filters, setFilters] = useState<FilterProps>(initialValues)
  const [interships, setInternships] = useState<any>(props.intershipsData)
  const [searchKeyword, setSearchKeyword] = useState<string>('')
  const [searchQuery, setSearchQuery] = useState<any>({});
  const [totalPages, setTotalPages] = useState<number>(0);
  const { country, searchValue, pageNo } = filters

  const debounceSearchQuery = (searchKeyValue: string) => {
    const search = _debounce(
      () => setFilters({ ...filters, searchValue: searchKeyValue }),
      500
    );
    setSearchQuery((prevSearch: any) => {
      if (prevSearch.cancel) {
        prevSearch.cancel();
      }
      return search;
    });
    search();
  };

  useEffect(() => {
    const url = searchValue ? `&name_contains=${searchValue}` : ''
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/country-internships?country=${country.replace(/ /g, '')}&_start=${(pageNo - 1) * 3}&_limit=${3}${url}`, 'GET', {}, '', false)
      .then((res: any) => {
        setInternships(res)
      })
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/country-internships/count?country=${country.replace(/ /g, '')}${url}`, 'GET', {}, '', false)
      .then((res: any) => {
        setTotalPages(Math.ceil(res / 3))
      })
  }, [filters])

  const totalPagesArray = Array.from(Array(totalPages).keys())
  return (
    <>
      <div id='debounce-search-query' className={styles.edtech}>
        <Container>
          <div className={styles.breadcrum}>
            <Row className="text-center">
              <Col lg={8} md={8} xs={12} className={styles.centered}>
                <Breadcrumb>
                  <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href=""> Internships </Breadcrumb.Item>
                </Breadcrumb>
                <div className={styles.abttopContent}>
                  <div className={styles.abttopContentdesk} >
                    <h1>{props?.pageData?.title}</h1>
                    <p>{props?.pageData?.description}</p>
                  </div>
                </div>
                <Button
                    id='enquirebtn'
                    variant='primary'
                    size='lg'
                    className={`${styles.enquirebtn} btn ${isFrappeOrJotFormClass(props.pageData?.meta?.jotforms[0]?.jotformid || process.env.NEXT_PUBLIC_COMMON_JOTFORM_ID)}`}
                  >
                   { props?.pageData?.bannerBtn?.label || 'Enquire Now'}
                  </Button>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <Row>
                  <Col xs={12} md={12}>
                    <div className={styles.parentMain}>
                      <div className={styles.first}>
                        <CustomImage src={props?.pageData?.mainImageOneUrl} width={770} height={400} alt={props?.pageData?.mainImageOneAltTag} />
                      </div>
                      <div className={styles.second}>
                        <div className={styles.childa}>
                          <CustomImage src={props?.pageData?.mainImageTwoUrl} width={370} height={400} alt={props?.pageData?.mainImageTwoAltTag} />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <div id='study-contnt' className={styles.studyContent}>
        <Container>
          <Row>
            <Col xs={12} lg={12}>
              <h2>{props?.pageData?.futureReady?.sectionTitle}</h2>
            </Col>
            <Col xs={12} lg={6}>
              <div className={styles.service_content}>
                <CustomImage src={props?.pageData?.futureReady?.sectionImageUrl} width={490} height={444} alt={props?.pageData?.futureReady?.sectionImageAltTag} />
              </div>
            </Col>
            <Col xs={12} lg={6} >
              <div className={styles.offers}>
                <div className={styles.content}>
                  {props?.pageData?.futureReady?.sectionDescription}
                </div>
                <ul>
                  {props?.pageData?.futureReady?.sectionPoints?.length > 0 &&
                    props?.pageData?.futureReady?.sectionPoints.map((point: string, index: number) =>
                      <li key={index}>{point}</li>
                    )
                  }
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div id='seven-step' className={styles.sevenSteps}>
        <Container>
          <h2>{props?.pageData?.sevenSteps?.sectionTitle}</h2>
          <Row>
            <Col xs={10} lg={5} className={styles.centered}>
              <ol>
                <li>
                  <div className={styles.decimals}>1</div><span><CustomImage src="/new-images/couselling-icon.svg" alt="cousellingIco.svg" width={40} height={40} /></span><div >
                    <h3>Counselling</h3>
                    <p>Plan your Academic and Career Goals</p>
                  </div>
                </li>
                <li> <div className={styles.decimals}>2</div><span><CustomImage src="/new-images/test-prep.svg" alt="testPrep.svg" width={40} height={40} /></span><div >
                  <h3>Test Preparation</h3>
                  <p>Appear for Standardized Tests</p>
                </div>
                </li>
                <li> <div className={styles.decimals}>3</div><span><CustomImage src="/new-images/course-icon.svg" alt="courseIco.svg" width={40} height={40} /></span><div >
                  <h3>Course, Country & University Selection</h3>
                  <p>Select the Country, the Program and the University</p>
                </div>

                </li>
                <li> <div className={styles.decimals}>4</div><span><CustomImage src="/new-images/applic-icon.svg" alt="applicIco.svg" width={40} height={40} /></span><div >
                  <h3>Application & Admission</h3>
                  <p>Apply to your Preferred Universities or Institutions</p>
                </div>
                </li>
              </ol>
            </Col>
            <Col xs={10} lg={5} className={styles.centered}>
              <ol>
                <li> <div className={styles.decimals}>5</div><span><CustomImage src="/new-images/edu-loan-icon.svg" alt="eduLoanIco.svg" width={40} height={40} /></span><div >
                  <h3>Education Loan & Financials</h3>
                  <p>Apply for Education Loan and Arrange Requisite Financials</p>
                </div>
                </li>
                <li> <div className={styles.decimals}>6</div><span><CustomImage src="/new-images/visa-icon.svg" alt="visaIco.svg" width={40} height={40} /></span><div >
                  <h3>Visa Processing</h3>
                  <p>Pay your Deposit, Accept your Offer and Apply for Visa</p>
                </div>
                </li>
                <li> <div className={styles.decimals}>7</div><span><CustomImage src="/new-images/addisuppico.svg" alt="addiSuppIco.svg" width={40} height={40} /></span><div >
                  <h3>Additional Support</h3>
                  <p>Attend Pre-Departure Session, Avail Forex & Insurance and Fly Abroad</p>
                </div>
                </li>
              </ol>
            </Col>
          </Row>
        </Container>
      </div>
      <div>
        <WebinarEvents headingLevel={2}/>
      </div>
      <Testimonial title='Our students love us' bgColor='#FFFFFF' slug={`student-testimonials?type=coaching&_limit=15&_sort=id:DESC`} />
      <div className={styles.homePageLatestKcUpdates}>
        <KcNewLatestUpdates {...props} />
      </div>
      <div className={styles.homePageBlogs}>
        <FeaturedBlogs />
      </div>
      <div>
        <NeedGuidance classname={`${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`} />
      </div>
      {props.pageData?.faq &&
        <FaqComponent {...props.pageData.faq} />}
    </>
  )
}

export default Internship;